import { useState } from "react";
import { ChevronDown } from "react-feather";
import { useDeferredSort } from "../../../../common/useDeferredSort";
import { compareAlphanumeric } from "../../../utils/sorting";
import { CategoryView, PanelTypeView } from "./mapToViewable";
import PanelTypeSection from "./panelTypeSection";
import "../../../../../assets/typesManagerStyles.css";

interface CategorySectionProps {
    category: CategoryView;
    selectedPanelId: string | null;
}

const comparePanelTypeNames = (a: PanelTypeView, b: PanelTypeView) => {
    return compareAlphanumeric(a.name, b.name);
};

const CategorySection = ({ category, selectedPanelId }: CategorySectionProps) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleCategory = () => setIsExpanded(prevState => !prevState);

    const sortedPanelTypes = useDeferredSort(
        category.panelTypes,
        isExpanded,
        comparePanelTypeNames,
    );

    return (
        <div>
            <button onClick={toggleCategory} className="tm-button tm-category-title" aria-expanded={isExpanded}>
                {category.name}
                <ChevronDown
                    size={16}
                    className="tm-chevron"
                    style={{
                        transform: isExpanded ? "rotate(180deg)" : "",
                    }}
                />
            </button>
            {isExpanded &&
                sortedPanelTypes.map(
                    panelType =>
                        panelType.panels.length > 0 && (
                            <PanelTypeSection
                                key={panelType.id}
                                panelType={panelType}
                                selectedPanelId={selectedPanelId}
                                categoryName={category.name}
                            />
                        ),
                )}
        </div>
    );
};

export default CategorySection;
